// SAL6010_R01 DTO 정의
// - 화면 호환을 위한 alias 필드 포함 (헤더/상세)
import { SalEstimateDtlDto, SalEstimateHdrDto } from "src/dtos/estimate/salEstimateDto";
import { formatDate } from "src/utils/string/stringUtil";

export interface SAL6010_R01Dto {
	salEstimateHeaderDto: SAL6010_R01HeaderDto;
	salEstimateDetailDtoList: SAL6010_R01DetailDto[];
}

export interface SAL6010_R01HeaderDto extends SalEstimateHdrDto {
    // 화면 호환 및 기존 매출 화면 로직과의 alias 필드들
    salBillNo: string;
    salDt: string;
    deliveryDt: string;
    empNo: string;
    empNm: string;
    customNm: string;
    compNm: string;
    // 금액 alias (estimateAmt -> salAmt)
    salAmt: number;
    inserted: boolean;
	isModified: boolean;
}

// 기본값 정의 (헤더 단건 기본값)
export const defaultSAL6010_R01HeaderDto: SAL6010_R01HeaderDto = {
    valueIndex: 0,
    orderIndex: 0,
    orderIndexSeq: 0,
    
    salBillNo: '',
    salesEstimateNo: '',
    compCd: '1000',
    estimateDt: formatDate(new Date()),
    salDt: '',
    deliveryDt: '',
    customCd: '',
    customNm: '',
    compNm: '',
    moneyCd: '',
    vatType: '',
    
    estimateAmt: 0,
    salAmt: 0,
    vatAmt: 0,
    totalAmt: 0,
    
    dueDt: '',
    telNo: '',
    faxNo: '',
    email: '',
    
    post: '',
    address: '',
    detailAddress: '',
    
    estimateEmpNo: '',
    empNo: '',
    empNm: '',
    approveFlg: 'N',
    remark: '',
    
    insertDt: new Date(),
    insertUser: '',
    insertForm: '',
    updateDt: new Date(),
    updateUser: '',
    updateForm: '',
    inserted: false,
	isModified: false
};

export interface SAL6010_R01DetailDto extends SalEstimateDtlDto {
    // DetailBaseDto 제약 충족 및 화면 컬럼 호환을 위한 보조 필드들
    itemNm: string;
    itemSpec: string;
    unit: string;
    itemQty: number;
    itemPrice: number;
    modelNo?: string;
    id?: string | number;
    
}

// 기본값 정의 (상세 단건 기본값)
export const defaultSAL6010_R01DetailDto: SAL6010_R01DetailDto = {
    valueIndex: 0,
    orderIndex: 0,
    orderIndexSeq: 0,
    
    salesEstimateNo: '',
    itemNo: '',
    
    compCd: '1000',
    estimateDt: '',
    customCd: '',
    itemSeq: 1,
    itemCd: '',
    estimateUnit: '',
    
    // 보조 필드 기본값 (제약 충족)
    itemNm: '',
    itemSpec: '',
    unit: '',
    itemQty: 1,
    itemPrice: 0,
    inserted: false,
    isModified: false,
    modelNo: '',
    
    estimateQty: 1,
    estimatePrice: 0,
    dcAmt: 0,
    itemAmt: 0,
    orderQty: 1,
    
    remark: '',
    
    insertDt: new Date(),
    insertUser: '',
    insertForm: '',
    updateDt: new Date(),
    updateUser: '',
    updateForm: ''
};
